module.exports = __webpack_public_path__ + "img/profile-pic.b88d2435.jpeg";